function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .simulationTransparent {\n                fill: none;\n            }\n        "));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "simulationTransparent",
  width: 29,
  height: 29
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(6 6)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M79.5,81.158h.664v.664a.5.5,0,0,0,1,0v-.664h.664a.5.5,0,0,0,0-1h-.664V79.5a.5.5,0,0,0-1,0v.664H79.5a.5.5,0,0,0,0,1Z",
  transform: "translate(-76.377 -76.377)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M312.5,115h1.992a.5.5,0,0,0,0-1H312.5a.5.5,0,0,0,0,1Z",
  transform: "translate(-301.641 -110.215)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M309.822,367H307.5a.5.5,0,0,0,0,1h2.324a.5.5,0,0,0,0-1Z",
  transform: "translate(-296.807 -354.814)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M309.822,317H307.5a.5.5,0,0,0,0,1h2.324a.5.5,0,0,0,0-1Z",
  transform: "translate(-296.807 -306.475)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.51,317.145a.5.5,0,0,0-.7,0l-.478.478-.478-.478a.5.5,0,0,0-.7.7l.478.478-.478.478a.5.5,0,1,0,.7.7l.478-.478.478.478a.5.5,0,0,0,.7-.7l-.478-.478.478-.478A.5.5,0,0,0,91.51,317.145Z",
  transform: "translate(-86.044 -306.474)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.137,9V1.494A1.5,1.5,0,0,0,14.643,0H1.494A1.5,1.5,0,0,0,0,1.494V14.643a1.5,1.5,0,0,0,1.494,1.494H9A5.144,5.144,0,0,0,16.137,9Zm-1-7.51V7.9a5.136,5.136,0,0,0-6.574,0V1h6.076A.5.5,0,0,1,15.141,1.494ZM1.494,1H7.57V7.57H1V1.494A.5.5,0,0,1,1.494,1ZM1,14.643V8.566H7.57V9A5.136,5.136,0,0,0,7.9,15.141h-6.4A.5.5,0,0,1,1,14.643ZM11.854,16A4.15,4.15,0,1,1,16,11.854,4.155,4.155,0,0,1,11.854,16Z"
}));

var SvgSimulacao = function SvgSimulacao(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSimulacao, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/simulacao.c237489e.svg";
export { ForwardRef as ReactComponent };